import React, { useState } from "react";
import styles from "./DeleteAccount.module.css";
import { Button, TextField } from "@mui/material";
import { POST } from "../../config/api";

function DeleteAccount() {
    const [isLoading, setIsLoading] = useState(false);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");

    const handleDeleteAccount = async () => {
        if (email?.trim() && password?.trim()) {
            setIsLoading(true);
            const {status} = await POST(`/website/users/delete-account`, {}, {email: email.trim(), password: password.trim()});
            if (status === 200) {
                setEmail("");
                setPassword("");
                setError("");
                setError("Account deletion request sent.");
            } else {
                setError("Invalid username or password.");
            }
        } else {
            setError("Please fill in all fields.");
        }
        setIsLoading(false);
    };

    return (
        <div className={styles.container}>
            <h1 className={styles.title}>Delete Account</h1>
            <div className={styles.form}>
                <TextField
                    label="Email"
                    variant="filled"
                    fullWidth
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className={styles.input}
                />
                <TextField
                    label="Password"
                    type="password"
                    variant="filled"
                    fullWidth
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className={styles.input}
                />
                {error && <p className={styles.error}>{error}</p>}
                <Button
                    variant="contained"
                    color="warning"
                    onClick={handleDeleteAccount}
                    className={styles.button}
                    disabled={isLoading}
                >
                    {isLoading ? "Deleting..." : "Delete Account"}
                </Button>
            </div>
        </div>
    );
}

export default DeleteAccount;
